import { TrackVariableResponseDTO } from '@core/api/dtos/response/song/trackVariable'
import { TrackVariable } from '@core/api/entities/song/trackVariable'

export class TrackVariableMapper {
	static toEntity(data: TrackVariableResponseDTO): TrackVariable {
		return new TrackVariable({
			id: data.id,
			name: data.name,
			type: data.type,
			strength: data.strength,
		})
	}

	static toEntities(data: TrackVariableResponseDTO[]): TrackVariable[] {
		return data.map((item) => this.toEntity(item))
	}
}
